import moment from "moment/moment"

export const groupPendenciesByInformant = (occurrences) => {
  const bases = { serasa: [], spc: [], others: [] }

  if (!occurrences || occurrences.length === 0) {
    return bases
  }

  occurrences?.forEach((occurrence) => {
    switch (occurrence.informant) {
      case 'SERASA':
        bases.serasa.push(occurrence)
        break
      case 'SCPC':
        bases.spc.push(occurrence)
        break
      default:
        bases.others.push(occurrence)
        break
    }
  })
  return bases
}

export const formatPendenciesInformantBaseName = (base) => {
  const baseNames = {
    SERASA: 'Serasa',
    SCPC: 'SPC',
  }

  return baseNames[base] || base
}

export const builFinancialPendencydDate = (date) => {
  if (!date) return 'N/A'

  const [day, month, year] = date.split('-')
  if (!day || !month || !year)
    return 'N/A'

  return moment(`${year}-${month}-${day}`)
}
